/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type authActions$ref = any;
export type authActions = {
    readonly verifiedTradeStatus: string | null;
    readonly " $refType": authActions$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "authActions",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "verifiedTradeStatus",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0e159f1d52d8df9f6a0dceae69d2b609';
export default node;
